// @figma file=tbd node=tbd name="AspectRatio" set="tbd" verified=tbd

import * as AspectRatioPrimitive from '@radix-ui/react-aspect-ratio';
import * as React from 'react';

export interface AspectRatioProps
  extends React.ComponentPropsWithoutRef<typeof AspectRatioPrimitive.Root> {
  /**
   * Width-to-height ratio. Common values: 1 (square), 4/3, 16/9, 21/9.
   * @default 1
   */
  ratio?: number;
}

const AspectRatio = React.forwardRef<
  React.ElementRef<typeof AspectRatioPrimitive.Root>,
  AspectRatioProps
>(({ ratio = 1, ...props }, ref) => (
  <AspectRatioPrimitive.Root ref={ref} ratio={ratio} {...props} />
));
AspectRatio.displayName = 'AspectRatio';

export { AspectRatio };
